import React, { Component } from 'react';
import PropTypes from "prop-types";


class XBr extends Component{

    render(){
        const {
            className,
        } = this.props;

        return(
            <br className={className} />
        )
    }
}

XBr.propTypes = {
    className: PropTypes.string,
};

XBr.defaultProps = {
    className:""
};
export default  XBr;

